<template>

<app-wrapper>

    <com-settings />
    <com-list />

</app-wrapper>

</template>

<script>

import comList from './prices/List'
import comSettings from './prices/Settings'

export default {

    components: {
        'com-list': comList,
        'com-settings': comSettings
    }

}

</script>